import React, { PureComponent, Fragment } from "react";
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";

import { scaleLinear } from "d3-scale";
import { Tooltip as ReactTooltip } from "react-tooltip";
import geography from "components/SocialBoards/Youtube/world-50m.json";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import { selectFormat } from "components/Utils/Utils.js";

const cityScale = scaleLinear().domain([0, 37843000]).range([1.5, 30]);

class MarqueeTVWhere extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: this.props.data,
    opts: {
      type: "other",
    },
  });

  renderTable(data) {
    const { cells, title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "country",
        text: "Top Countries",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "140px", minWidth: "140px", textAlign: "right" },
        headerAlign: "right",
        formatter: (cell) => selectFormat("number", cell, "0,0"),
        sort: true,
      },
    ];

    const defaultSorted = [
      {
        dataField: "views",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }
    const filename = title.split(" ").join("_") || "spreadsheet";
    const sortedData = data.sort((a, b) => (a.views < b.views ? 1 : -1));

    return (
      <ToolkitProvider
        keyField="id"
        data={sortedData.slice(0, 10)}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  render() {
    const { data } = this.props;
    data.data.forEach((d) => (d.coordinates = [d.longitude, d.latitude]));
    const max = Math.max(...data.data.map((d) => d.views)) || 1;
    cityScale.domain([0, max]);

    return (
      <Fragment>
        <div className="row">
          <div className="col-lg-7 col-12 pr-4">
            <ComposableMap
              projectionConfig={{ scale: 205 }}
              width={980}
              height={551}
              style={{
                width: "100%",
                height: "auto",
              }}
            >
              <ZoomableGroup center={[0, 20]}>
                <Geographies geography={geography}>
                  {(geographies, projection) =>
                    geographies.geographies.map(
                      (geography, i) =>
                        geography.id !== "ATA" && (
                          <Geography
                            key={i}
                            geography={geography}
                            projection={projection}
                            style={{
                              default: {
                                fill: "#ECEFF1",
                                stroke: "#607D8B",
                                strokeWidth: 0.75,
                                outline: "none",
                              },
                              hover: {
                                fill: "#ECEFF1",
                                stroke: "#607D8B",
                                strokeWidth: 0.75,
                                outline: "none",
                              },
                              pressed: {
                                fill: "#ECEFF1",
                                stroke: "#607D8B",
                                strokeWidth: 0.75,
                                outline: "none",
                              },
                            }}
                          />
                        )
                    )
                  }
                </Geographies>

                {data.data.map((marker, i) => (
                  <Marker
                    key={i}
                    marker={marker}
                    coordinates={marker.coordinates}
                  >
                    <circle
                      cx={0}
                      cy={0}
                      r={cityScale(marker.views)}
                      fill="blueviolet"
                      stroke="#607D8B"
                      strokeWidth="1"
                      strokeOpacity="0.8"
                      data-tooltip-id="watching-summary-tooltip"
                      data-tooltip-html={
                        marker.country +
                        ": " +
                        selectFormat("number", marker.views, "0,0")
                      }
                    />
                  </Marker>
                ))}
              </ZoomableGroup>
            </ComposableMap>

            <ReactTooltip
              id="watching-summary-tooltip"
              className="title-tooltip-header"
            />
          </div>

          <div className="col-lg-5 col-12">{this.renderTable(data.data)}</div>
        </div>
      </Fragment>
    );
  }
}

export default MarqueeTVWhere;
